var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXledger = function SvgXledger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 90 90"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--huma-color-integration-xledger)",
    d: "M89 90H16.344C6.266 90 0 83.586 0 73.24V0h72.648C83.04 0 89 6.113 89 16.769zM4.239 4.26v68.98c0 8.065 4.302 12.51 12.1 12.51H84.76V16.77c0-8.3-4.075-12.51-12.113-12.51l-68.41.002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--huma-color-integration-xledger)",
    d: "M80 10.186H65.307L48.934 31.102v10.396h6.569zM11 10l24.648 31.504h6.666V31.236l-16.612-21.23zm.478 69H26.17l16.144-20.627V48.217h-6.752zm37.456-30.783V58.5l15.887 20.317h14.697l-23.932-30.6z"
  })));
};
export default SvgXledger;